import { CenteredLoadingIndicator } from "../../molecules/Molecules"
import React from "react"

export default function RegisteringLoadingIndicator(): JSX.Element {
  return (
    <div className="vh-100 flex items-center justify-center">
      <CenteredLoadingIndicator />
    </div>
  )
}
